import moment from "moment";
import React, { useState, Fragment, useRef } from "react";
import { Button, Modal, Image } from "react-bootstrap";
import { CAR_COLORS, ORDER_TYPE_NAME } from "../../../enums/OrderEnums";
import ReactHtmlParser from "react-html-parser";
import { useReactToPrint } from "react-to-print";

function KOTPrinting(props) {
  const [open, setOpen] = useState(false);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <div>
      <React.Fragment>
        <div variant="div" align="center" onClick={() => setOpen(true)}>
          {props?.iconButton ? (
            <Button
              variant="link"
              className="enIconBtn mr-3"
              style={{ color: "black" }}
            >
              <i class="fa fa-print" aria-hidden="true"></i>
            </Button>
          ) : (
            <>
              <Image
                src={require("../../../assets/images/iconButton/right_arrow_green.svg")}
                alt="Getting Prep"
                title="Getting Prep"
                fluid
                width="40"
              />
              <div className="f10-500">{props?.buttonText ? props?.buttonText : "Getting Prep"}</div>
            </>
          )}
        </div>

        <Modal show={open} onHide={() => setOpen(false)} centered>
          <Modal.Header className="py-0 pt-3 border-0" closeButton>
            <Modal.Title className="f24-700">Print Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="border px-4 py-2"
              style={{ maxWidth: "420px", borderColor: "black" }}
              ref={componentRef}
            >
              <div className="text-center f16-700 my-2 ">
                <Image
                  src={require("../../../assets/images/kot.png")}
                  alt="amealio"
                  title="amealio"
                  fluid
                  width="120"
                />
              </div>
              <div className="text-center f20-700 mt-2 ">KOT</div>
              <div className="text-center f20-700 mt-2 my-2 ">
                {props?.merchantName?.restaurant_name || ""}
              </div>
              <hr style={{ backgroundColor: "black" }} />
              <div className="row my-2">
                <div className="col-4"></div>
                <div className="col-4">
                  <div className="text-center f16-700">
                    {ORDER_TYPE_NAME[props?.data?.order_type]}
                  </div>
                </div>
                <div className="col-4 text-right f14-500">
                  {props?.data?.order_type === 3
                    ? `Pax No. ${props?.data?.totalDinePax}`
                    : "-"}
                </div>
              </div>
              <div className="row">
                <div className="col-6 f14-500 py-1">Order Reference:</div>
                <div className="col-6 f14-700 py-1">
                  {props?.data && props?.data?.order_type === 1 ? (
                    <Fragment>
                      <div>
                        <p className="f14-500">
                          {props?.data?.curb_side_details !== undefined &&
                          props?.data?.curb_side_details !== null ? (
                            <React.Fragment>
                              <p className="f14-500 mb-2">
                                {props?.data &&
                                  props?.data?.curb_side_details?.number}
                              </p>
                              <p className="f14-500">
                                {props?.data &&
                                  props?.data?.curb_side_details &&
                                  props?.data?.curb_side_details?.model}
                                {" | "}
                                {props?.data &&
                                  props?.data?.curb_side_details &&
                                  props?.data?.curb_side_details?.make}
                                {" | "}
                                {props?.data &&
                                  props?.data?.curb_side_details &&
                                  props?.data?.curb_side_details
                                    .vehical_type_value}
                                {" | "}
                                {props?.data &&
                                  props?.data?.curb_side_details &&
                                  props?.data?.curb_side_details.vehical_type}
                                {" | "}
                                {props?.data &&
                                  props?.data?.curb_side_details &&
                                  props?.data?.curb_side_details?.year}
                                {" | "}
                                {CAR_COLORS &&
                                  CAR_COLORS.map((data, index) => {
                                    return data?.value ===
                                      props?.data?.curb_side_details?.color
                                      ? data?.name
                                      : "";
                                  })}
                              </p>
                              <p className="f14-500 mt-2">
                                Pickup Point:
                                <span className="f14-500">
                                  {" "}
                                  {
                                    props?.data?.curb_side_details?.pickUpPoint
                                      ?.name
                                  }
                                </span>
                              </p>
                            </React.Fragment>
                          ) : (
                            "N/A"
                          )}
                        </p>
                      </div>
                    </Fragment>
                  ) : props?.data?.order_type === 3 ? (
                    <Fragment>
                      {props?.data?.dine_in_details?.table_number}
                    </Fragment>
                  ) : props?.data?.order_type === 7 &&
                    props?.data?.deliveryAddress ? (
                    <React.Fragment>
                      <a
                        target="_blank"
                        style={{ textDecoration: "none", color: "inherit" }}
                        href={`https://www.google.com/maps/place/${props?.data?.deliveryAddress?.location?.latitude},${props?.data?.deliveryAddress?.location?.longitude}`}
                      >
                        <p className="f10-500 mb-2">
                          {props?.data?.deliveryAddress?.address1}
                        </p>
                      </a>
                      <p className="f10-400 mb-2">
                        {props?.data?.deliveryAddress?.area || ""},{" "}
                        {props?.data?.deliveryAddress?.city || ""}
                      </p>
                    </React.Fragment>
                  ) : props?.data?.order_type === 0 ||
                    props?.data?.order_type === 2 ? (
                    <Fragment>
                      <p>Self Pick-up</p>
                    </Fragment>
                  ) : (
                    <p>'N/A'</p>
                  )}
                </div>
                <div className="col-6 f14-500 py-1">Customer Name:</div>
                <div className="col-6 f14-700 py-1">
                  {props.data &&
                  props.data.user_details &&
                  props.data.user_details.first_name &&
                  props.data.user_details.last_name
                    ? props.data.user_details.first_name +
                      " " +
                      props.data.user_details.last_name
                    : ""}
                </div>
                <div className="col-6 f14-500 py-1">Order Date and Time:</div>
                <div className="col-6 f14-700 py-1">
                  {moment(
                    new Date(
                      (props?.data?.order_type === 0 ||
                        props?.data?.order_type === 1) &&
                      !props?.data?.now
                        ? props?.data?.later_date
                        : props?.data?.createdAt
                    )
                  ).format("DD MMM YYYY, HH : mm A")}
                </div>
                <div className="col-6 f14-500 py-1">Order ID:</div>
                <div className="col-6 f14-700 py-1">
                  {props?.data?.order_id}
                </div>
              </div>
              {/* <hr style={{ backgroundColor: "black" }} /> */}
              <div className="pr-3 pl-3">
                <div
                  className="row p-2 mt-2 mb-2 f14-500"
                  style={{
                    borderTop: "1px dashed black",
                    borderBottom: "1px dashed black",
                  }}
                >
                  <div className="col-8 p-0">Item</div>
                  <div className="col-4 ">Quantity</div>
                </div>
                {props?.data?.order_items.map((item) => {
                  return (
                    <div className="row p-2 border-bottom">
                      <div className="col-8 p-0">
                        <div className="f14-700">{item?.item?.name}</div>
                        <div className="f12-500 text-break">
                          {item &&
                          item.customised_details &&
                          item.customised_details.customised ? (
                            <div>
                              {ReactHtmlParser(
                                props.prepareLevels(item?.customised_details)
                              )}
                            </div>
                          ) : (
                            " "
                          )}{" "}
                          {item && item.addOns.length > 0 ? (
                            <>
                              {props
                                .getAddOns(item && item.addOns)
                                .map((data, index) => {
                                  return (
                                    <div
                                      className="row d-flex align-items-center justify-content-between m-0"
                                      key={index}
                                    >
                                      <div className="col px-2 f10-400">
                                        {data.name}
                                      </div>
                                      <div className="col px-2 f10-500">
                                        {data.multiple}
                                      </div>
                                      <div className="col-12 pl-1 pr-3">
                                        <hr className="m-1" />
                                      </div>
                                    </div>
                                  );
                                })}
                              {props.getAddOnsString(item && item.addOns)}
                            </>
                          ) : (
                            <Fragment> </Fragment>
                          )}
                          {/* <>
                            {item?.size?.description !== undefined &&
                            item?.size?.description !== null &&
                            item?.size?.description !== "" ? (
                              <div className="f14-500 mb-2 d-flex text-capitalize">
                                Size - {item?.size?.description}
                              </div>
                            ) : (
                              ""
                            )}
                            {item?.size?.uom !== undefined &&
                            item?.size?.uom !== null &&
                            item?.size?.uom !== "" ? (
                              <div className="f14-500 d-flex text-capitalize">
                                UOM - {item?.size?.uom}
                              </div>
                            ) : (
                              ""
                            )}
                          </> */}
                        </div>
                        {item && item.notes !== "" ? (
                          <p className="mt-2">Notes: {item?.notes || ""}</p>
                        ) : (
                          <> </>
                        )}
                      </div>
                      <div className="col-4 f14-700">{item?.quantity}</div>
                    </div>
                  );
                })}
              </div>
              {/* <hr style={{ backgroundColor: "black" }} /> */}
              <div className="f16-500 my-2">Kitchen Notes:</div>
              <div className="f14-500">{props?.data?.notes}</div>
              <div className="f14-500 my-2">Allergies: <span style={{ color: "red" }}>{props?.data?.allergy_information?.map((allergy) => allergy?.description || "")}</span></div>
            </div>
            <div className="d-flex align-items-center pt-4">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                style={{ border: "2px solid #ee3a23" }}
                className="btn-lg mr-4 px-5"
                // onClick={(e) => props.next()}
                onClick={handlePrint}
              >
                Print
              </Button>
              {props?.next ? (
                <Button
                  variant="outline-danger"
                  className="btn-lg mr-4 px-5"
                  onClick={() => props.next()}
                >
                  Continue
                </Button>
              ) : null}
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    </div>
  );
}

export default KOTPrinting;
